const TeamHyfye = () => {
    return (
    <section id="team">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12 offset-lg-2">
            <div className="title_dark title_border text-center">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">Our Team</h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                Meet the passionate team behind Hyfye — innovators, builders, and believers in creating a global economy of gratitude.
              </p>
            </div>
          </div>
        </div>
    
        <div className="row small_space">
    
          <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.4s">
              <div className="team_img gradient_box text-center">
                <img src="assets/images/team/Derek.png" alt="Derek Castro" />
              </div>
              <div className="team_info text-center">
                <h4>Derek Castro</h4>
                <p>Head of Marketing</p>
                <p className="small_text">Derek leads our global marketing efforts with a passion for creative storytelling and brand building.</p>
              </div>
            </div>
          </div>
    
          <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.6s">
              <div className="team_img gradient_box text-center">
                <img src="assets/images/team/Jessica.png" alt="Jessica Bell" />
              </div>
              <div className="team_info text-center">
                <h4>Jessica Bell</h4>
                <p>Head of Sales</p>
                <p className="small_text">Jessica drives our partnerships and investor relationships, bringing years of experience in blockchain sales leadership.</p>
              </div>
            </div>
          </div>
    
          <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.8s">
              <div className="team_img gradient_box text-center">
                <img src="assets/images/team/Martin.png" alt="Alvaro Martin" />
              </div>
              <div className="team_info text-center">
                <h4>Alvaro Martin</h4>
                <p>Blockchain Developer</p>
                <p className="small_text">Alvaro is a blockchain innovator focused on developing Hyfye’s decentralized infrastructure and smart contract systems.</p>
              </div>
            </div>
          </div>
    
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="1s">
              <div className="team_img gradient_box text-center">
                <img src="assets/images/team/Maria.png" alt="Maria Willium" />
              </div>
              <div className="team_info text-center">
                <h4>Maria Willium</h4>
                <p>Community Manager</p>
                <p className="small_text">Maria builds and supports our global Hyfye community — connecting people, answering questions, and spreading positivity.</p>
              </div>
            </div>
          </div>
    
        </div>
      </div>
    </section>
    )}
    export default TeamHyfye;
    